module.exports = __webpack_public_path__ + "static/media/Crystal Maiden.d7f72360.png";